module.exports = __webpack_public_path__ + "static/img/100x100_ICONS_5.0451741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/100x100_ICONS_5.png
// module id = imzQ
// module chunks = 0